/*
 * $Id:: service.js 2021/02/24 05:35 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { sendRequest } from '../../common/utils';

export const queryForgotPassword = (email) => {
    return sendRequest({
        url: '/user/password/reset',
        method: 'POST',
        body: { email },
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};

export const queryValidateResetToken = (token) => {
    return sendRequest({
        url: '/user/password/validate-token',
        method: 'POST',
        body: { token },
    })
        .then((response) => {
            if (!response.valid) return { error: { description: response.message, code: 400 } };
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};

export const queryResetPassword = (payload) => {
    return sendRequest({
        url: '/user/password/confirmation',
        method: 'POST',
        body: payload,
    })
        .then((response) => {
            return { ...response, ok: true };
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};

export const validateEmailAndPassword = ({ userName, email, password }) => {
    return sendRequest({
        url: '/user/registration/validation',
        method: 'POST',
        body: { userName, email, password },
    })
        .then((response) => {
            return { ...response, fromAction: 'validateCredentials' };
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};

export const createAccount = (params) => {
    return sendRequest({
        url: '/user/registration/creation',
        method: 'POST',
        body: { ...params },
    })
        .then((response) => {
            return { ...response, fromAction: 'registerAccount' };
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};

export const requestVerificationCode = (params) => {
    return sendRequest({
        url: '/user/registration/resend-token',
        method: 'POST',
        body: { ...params },
    })
        .then((response) => {
            return { ...response, fromAction: 'requestNewVerificationCode' };
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};

export const requestAccountVerification = (params) => {
    return sendRequest({
        url: '/user/registration/confirmation',
        method: 'POST',
        body: { ...params },
    })
        .then((response) => {
            return { ...response, fromAction: 'verifyAccount' };
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};

export const requestUserInfo = () => {
    return sendRequest({
        url: '/auth/me',
        method: 'GET',
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code } };
        });
};
